const $ = require('jquery');
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import render from "../../utilities/render";
import {isPresent} from "../../utilities/general";
import { createPreventDefault } from '../../utilities/general';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import EditChecker from '../../components/EditChecker/EditChecker';
//import {SUCCESS_MODAL_TIMEOUT} from "../../constants";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../constants";

import {buildExport,prepareDataToSendController,isEdit,doAjax,pushFilterSessionCacheState,isNew,isDeleteView,isOnlyLookupDataUpdate,retriveCriteriaObjectByOperation} from "../../utilities/filtersutil";
import {fixitOrderLookupFieldDropdown} from "./filter/fixitOrderLookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
const _ = require("underscore");
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";
const modalHtml = require("../../sharedHtml/modal.html");


let els = {};
const elsModal = {};
const elsModalMap = {};
const elsMap = {
	addOrderFormElement:".manage-fixitorder-form"
	,submitOrderForm:".submit-order-form"
	,cancelOrderForm:".add-order-cancel-btn"
	,updateOrderForm:".update-order-form"
	,oreStatus: "#oreStatus"	
}

const targetAddOrderSelector = "#manage-fixit-orders"; 
const customValidateProps = { 
  errorPlacement: function (error, element) {
    let appendClosest = $(element).data('error-placement-append-closest');
    if (appendClosest) {
      $(element).closest(appendClosest).append(error);
    } else {
      error.insertAfter(element);
    }
  }
};
run(targetAddOrderSelector, (outerEl) => {
  const $ = require('jquery');
  const date = new Date();
  const saveOrderUrl = outerEl.data("saveorder-url");
  const cancelOrderUrl =  outerEl.data("canceladdorder-url");
  const editOrderFlag = outerEl.data("editorder");
  const orderstatus = outerEl.data("orderstatus");
  const checkVzwOrdNumIsDuplicateUrl = outerEl.data('check-vzwordnum-isduplicate-url');

function init() {
        setElements();
        bindElements();        
}

function setElements() {
        setElementsFromScope(els, elsMap, outerEl);
}

function bindElements() {
	els.submitOrderForm.click(submitCreateOrderForm);
	setDefaultValues();
	els.updateOrderForm.click(submitCreateOrderForm);
}

function submitCreateOrderForm(){
  let duplicateOrd = "false" ;
  $(".manage-fixitorder-form").valid();

 
  //validate vzworder already exists only for new order. true indicates vzworder already exists
  if(editOrderFlag != undefined  && editOrderFlag == ""){
    $.ajax({
      data: {
        vzwOrderNum: $("#oreVzwOrder").val()
        ,vzwLocation: $("#oreVzwLocation").val()
        ,vzwSapDeliveryNum: $("#oreSapDeliveryNum").val()
        ,vzwSku: $("#oreSku").val()
      },
      url: checkVzwOrdNumIsDuplicateUrl,
      async: false,
      dataType: 'text',
      type: 'POST',
      success: function (dataResponse) {
        if (dataResponse != null) {
          duplicateOrd = dataResponse;
          if(dataResponse == "true"){
            $("#oreDupOrder-exists-error").show();   
            return false;
          }else if(dataResponse == "false"){
           $("#oreDupOrder-exists-error").hide();  
          }
        }
      }
    });
  }


	if($("#oreOrderDateString").val().length == 0){
	  $("#oreOrderDateString-error").show();
    return;
	}else{
	    //validate order date format.
      var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
      if (!(date_regex.test($("#oreOrderDateString").val()))) {
        $("#oreOrderDateStringformat-error").show();        
        return false;
      }else{
        $("#oreOrderDateString-error").hide();
        $("#oreOrderDateStringformat-error").hide(); 
      }
	}

  //validate Error date
  if($("#oreErrorDateString").val().length == 0){
    $("#oreErrorDateString-error").hide(); 
  }else{
    //validate error date format.
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    if (!(date_regex.test($("#oreErrorDateString").val()))) {
      $("#oreErrorDateString-error").show();        
      return false;
    }else{
      $("#oreErrorDateString-error").hide();
    }
  }

  //validate Shipped Date

  if($("#oreShippedDateString").val().length == 0){
    $("#oreShippedDateString-error").hide(); 
  }else{
    //validate shipped date format.
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    if (!(date_regex.test($("#oreShippedDateString").val()))) {
      $("#oreShippedDateString-error").show();        
      return false;
    }else{
      $("#oreShippedDateString-error").hide();
    }
  }
  
  if($(".manage-fixitorder-form").valid() && duplicateOrd == "false") { 
    $("#fixitOrderForm").submit();
      var submitModalFlow = new SubmitModalFlow();
      submitModalFlow.init();
      submitModalFlow.showLoadingModal();
      submitModalFlow.showSuccessModal();
      setTimeout(function () {
        submitModalFlow.hideAllModals();
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);      
    }	
}

function setDefaultValues(){
	//By default set status to OPEN and disable the dropdown for new order.
	
	if(editOrderFlag != undefined  && editOrderFlag!= "" && orderstatus != undefined && orderstatus !=""){
		$("#oreStatus option").each(function () {
		 if(this.value == orderstatus){
			$(this).attr("selected", "selected");
            return;
		 }  
    });		
	}else{	
		$("#oreStatus option").each(function () {
			 if(this.value == 'OPEN'){
				$(this).attr("selected", "selected");
				return;
			 }			
		});
	}	
}

$("#oreOrderDateString").on("change", function () {
  if($("#oreOrderDateString").val().length == 0){
    $("#oreOrderDateStringformat-error").hide(); 
	  $("#oreOrderDateString-error").show();
    return;
	}else{
    $("#oreOrderDateString-error").hide();
    //validate order date format.
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    if (!(date_regex.test($("#oreOrderDateString").val()))) {
      //$("#oreOrderDateString-error").show();
      $("#oreOrderDateStringformat-error").show();        
      return false;
    }else{
      $("#oreOrderDateString-error").hide();
      $("#oreOrderDateStringformat-error").hide(); 
    }
	}
});

$("#oreErrorDateString").on("change", function () {
  if($("#oreErrorDateString").val().length == 0){
    $("#oreErrorDateString-error").hide(); 
	}else{
    //validate error date format.
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    if (!(date_regex.test($("#oreErrorDateString").val()))) {
      $("#oreErrorDateString-error").show();        
      return false;
    }else{
      $("#oreErrorDateString-error").hide();
    }
	}
});

$("#oreShippedDateString").on("change", function () {
  if($("#oreShippedDateString").val().length == 0){
    $("#oreShippedDateString-error").hide(); 
	}else{
    //validate shipped date format.
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    if (!(date_regex.test($("#oreShippedDateString").val()))) {
      $("#oreShippedDateString-error").show();        
      return false;
    }else{
      $("#oreShippedDateString-error").hide();
    }
	}
});


  $("#oreSku").on("change", function () {
  if($.trim($("#oreVzwOrder").val()).length != 0){
    //Make ajax call
    isDuplicateVzOrder();
  }else{
   $("#oreDupOrder-exists-error").hide(); 
    
  }
});

function isDuplicateVzOrder(){
  $.ajax({
    data: {
      vzwOrderNum: $("#oreVzwOrder").val()
      ,vzwLocation: $("#oreVzwLocation").val()
      ,vzwSapDeliveryNum: $("#oreSapDeliveryNum").val()
      ,vzwSku: $("#oreSku").val()
    },
    url: checkVzwOrdNumIsDuplicateUrl,
    async: false,
    dataType: 'text',
    type: 'POST',
    success: function (dataResponse) {
      if (dataResponse != null) {
        if(dataResponse == "true"){
          $("#oreDupOrder-exists-error").show(); 
          return false;
        }else if(dataResponse == "false"){
          $("#oreDupOrder-exists-error").hide();    
        }
      }
    }
  });
}

init();

//check if class is disabled
function shallAllowClick(currentObj) {
    return !$(currentObj).hasClass("disabled");
}

});



// WEBPACK FOOTER //
// ./src/pages/fixitOrders/addfixitorder.js